'use strict';

exports.__esModule = true;
exports.getState = getState;

var _componentTracker = require('../componentTracker');

var _constants = require('../constants');

/* eslint-env browser */
/* eslint-disable import/prefer-default-export */
function getState() {
  var _ref;

  var componentByIds = (0, _componentTracker.getAll)();
  var componentIds = Object.keys(componentByIds).reduce(function (ids, id) {
    var component = componentByIds[id];
    if (component.loadingPromise) return [].concat(ids, [component.componentId]);
    return ids;
  }, []);
  return _ref = {}, _ref[_constants.COMPONENT_IDS] = componentIds, _ref;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/loadable-components/snap/index.js
// module id = 85
// module chunks = 3